__webpack_require__.p = "https://static.paymentiq.io/bo2/2.50.0/";